import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getProducts } from "../../../../client/administration/products";
import figure1 from "../../../../assets/images/logos/logoTasaBalanza.svg"; 
import figure2 from "../../../../assets/images/weighing/actions/descargar.png"; 
import figure3 from "../../../../assets/images/weighing/actions/compartir.png"; 
import figure4 from "../../../../assets/images/weighing/actions/escanear.png"; 
import MenuAdmin from "../../../../components/layout/menu";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { format } from 'date-fns'; 
import { es } from 'date-fns/locale';
import Programate from "../../../../components/layout/footer";

export default function Ticket() {
    const [products, setProducts] = useState([]);
    const location = useLocation();
    const {eventData, visitaData} = location.state || {};
    console.log("eventData:" ,eventData);
    console.log("visitaData:" , visitaData);

    const isEvent = eventData?.idVisit !== undefined; // Si tiene un idVisit, es un evento
    const visitData = isEvent ? eventData.visit : eventData; // Si no es un evento, usa los datos de la visita directamente



    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await getProducts();
                const productOptions = response.data.map(product => ({
                    value: product.id,
                    label: product.productName,
                }));
                setProducts(productOptions);
            } catch (error) {
                console.error("Error fetching products:", error);
            }
        };

        fetchProducts();
    }, []);

    // Función para obtener el nombre del producto por su ID
    const getProductNameById = (idProduct) => {
        const product = products.find((product) => product.value === idProduct);
        return product ? product.label : "-";
    };
    
    const handleScanClick = () => {
        navigate("/ingresoQR");  
    };

    const formatVisitDateRange = (startDateScheduled, finalDateScheduled) => {
        const startDate = new Date(startDateScheduled);
        const finalDate = new Date(finalDateScheduled);
    
        // Formatear las fechas
        const startDateFormatted = format(startDate, 'dd \'de\' MMMM hh:mm aaaa', { locale: es });
        const finalDateFormatted = format(finalDate, 'hh:mm aaaa', { locale: es });
    
        // Comparar las fechas
        if (startDate.toDateString() === finalDate.toDateString()) {
            // Si la visita termina el mismo día
            return `${startDateFormatted} a ${finalDateFormatted}`;
        } else {
            // Si termina en otra fecha
            const finalDateDayFormatted = format(finalDate, 'dd \'de\' MMMM', { locale: es });
            return `${startDateFormatted} a ${finalDateDayFormatted} ${finalDateFormatted}`;
        }
    };
    
    const handleDownload = () => {
        const doc = new jsPDF();
        const pdfContent = document.getElementById("pdf");

        const marginX = 10; // Margen izquierdo y derecho
        const marginY = 10; // Margen superior e inferior
    
        if (window.innerWidth > 1000) {
            doc.html(pdfContent, {
                callback: function (doc) {
                    doc.save("ticket_pesaje.pdf"); 
                },
                x: marginX,
                y: marginY,
                width: 180 - marginX * 2, 
                windowWidth: 775, 
            });
        } else {
            // Si la pantalla es más pequeña, usar una vista más simple
            doc.html(pdfContent, {
                callback: function (doc) {
                    doc.save("ticket_pesaje.pdf");
                },
                x: marginX,
                y: marginY,
                width: 180 - marginX * 2,
            });
        }
    };


    const formatDate = (dateString) => {
        const options = { 
            day: '2-digit', 
            month: 'long', 
            hour: 'numeric', 
            minute: 'numeric', 
            hour12: true // Asegura que se use el formato de 12 horas
        };
        const date = new Date(dateString);
        return date.toLocaleString('es-ES', options).replace(',', ''); // Reemplaza la coma para un mejor formato
    };

    const pesoInicial = eventData?.inputWeighting || null; // Peso inicial
    const pesoFinal = eventData?.ouputWeighting || null; // Peso final
    
    // Cálculo del peso neto con validación
    let pesoNeto;
    if (pesoInicial !== null && pesoFinal !== null) {
        pesoNeto = Math.abs(pesoInicial - pesoFinal) + " kg"; // Cálculo del peso neto
    } else {
        pesoNeto = "-"; // Mostrar guion si no hay peso inicial o final
    }

    return (
        <div className='flex w-full h-screen'>
            <MenuAdmin isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
            <div className={`flex-1 transition-all duration-300 ml-0 ${isMenuOpen ? "lg:ml-[220px] " : "ml-0"} w-[100%]`}>       
                <div className="flex flex-col justify-between min-h-screen">
                    <div className="flex flex-col pt-24 md:pt-44  lg:pt-40 xl:pt-40  justify-start  bg-white py-16 lg:px-[15%]">
                            <img
                                src={figure1}
                                alt="Taza"
                                className="hidden xl:ml-10 md:ml-10 md:block w-[105px] h-[41px] lg:w-[105px] lg:h-[41px] xl:w-[105px] xl:h-[41px]" // Muestra figure3 en pantallas medianas y grandes
                            />
                        <div id="pdf" className="w-full px-[5%] gap-4 pt-6 flex flex-col items-center justify-center ">
                            <p className="text-blue text-[32px] font-itcbold mb-6">Ticket de pesaje</p>
                            
                            <div className="flex items-center justify-between w-full gap-3 md:gap-24 xl:gap-60">
                                <div className="w-[60%] justify-start">
                                    <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Nombre del conductor</p>
                                </div>
                                <div className="w-[40%] justify-start">
                                    <p className="text-gray md:text-[20px] text-base font-itcbook">{visitData?.driverName || visitaData?.driverName || "-"} </p>
                                </div>
                            </div>
            
                            <div className="flex items-center justify-between w-full gap-3 md:gap-24 xl:gap-60">
                                <div className="w-[60%] justify-start">
                                    <p className="md:text-2xl text-[18px] text-blue font-itcmedium">DNI</p>
                                </div>
                                <div className="w-[40%] justify-start">
                                    <p className="text-gray md:text-[20px] text-base font-itcbook">{visitData?.dni  || visitaData?.dni || "-"}</p>
                                </div>
                            </div>
            
            
                            <div className="flex items-center justify-between w-full gap-3 md:gap-24 xl:gap-60">
                                <div className="w-[60%] justify-start">
                                    <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Placa</p>
                                </div>
                                <div className="w-[40%] justify-start">
                                    <p className="text-gray md:text-[20px] text-base font-itcbook">{visitData?.plate || visitaData?.plate || "-"}</p>
                                </div>
                            </div>
            
                            <div className="flex items-center justify-between w-full gap-3 md:gap-24 xl:gap-60">
                                <div className="w-[60%] justify-start">
                                    <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Tipo de vehículo</p>
                                </div>
                                <div className="w-[40%] justify-start">
                                    <p className="text-gray md:text-[20px] text-base font-itcbook">{visitData?.typeVehicle || visitaData?.typeVehicle || "-"}</p>
                                </div>
                            </div>
            
                            <div className="flex items-center justify-between w-full gap-3 md:gap-24 xl:gap-60">
                                <div className="w-[60%] justify-start">
                                    <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Empresa</p>
                                </div>
                                <div className="w-[40%] justify-start">
                                    <p className="text-gray md:text-[20px] text-base font-itcbook">{visitData?.companyName || visitaData?.companyName || "-"}</p>
                                </div>
                            </div>
            
                            <div className="flex items-center justify-between w-full gap-3 md:gap-24 xl:gap-60">
                                <div className="w-[60%] justify-start">
                                    <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Fecha agendada</p>
                                </div>
                                <div className="w-[40%] justify-start">
                                    <p className="text-gray md:text-[20px] text-base font-itcbook">     {formatVisitDateRange(
        visitaData?.startDateScheduled || visitData?.startDateScheduled,
        visitaData?.finalDateScheduled || visitData?.finalDateScheduled
    ) || "-"} 
                                    </p>
                                </div>
                            </div>
    
                            <div className="flex items-center justify-between w-full gap-3 md:gap-24 xl:gap-60">
                                <div className="w-[60%] justify-start">
                                    <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Destino</p>
                                </div>
                                <div className="w-[40%] justify-start">
                                    <p className="text-gray md:text-[20px] text-base font-itcbook">{visitData?.area || visitaData?.area || "-"}</p>
                                </div>
                            </div>
    
                            <div className="flex items-center justify-between w-full gap-3 md:gap-24 xl:gap-60">
                                <div className="w-[60%] justify-start">
                                    <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Hora de llegada</p>
                                </div>
                                <div className="w-[40%] justify-start">
                                    <p className="text-gray md:text-[20px] text-base font-itcbook">
                                        {isEvent ? (eventData?.dateOfEntry ? formatDate(eventData.dateOfEntry) : "-") : "-"}
                                    </p>
                                </div>
                            </div>
    
                            <div className="flex items-center justify-between w-full gap-3 md:gap-24 xl:gap-60">
                                <div className="w-[60%] justify-start">
                                    <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Peso inicial</p>
                                </div>
                                <div className="w-[40%] justify-start">
                                    <p className="text-gray md:text-[20px] text-base font-itcbook">{eventData?.inputWeighting ? `${eventData.inputWeighting} kg` : "-"}</p>
                                </div>
                            </div>
            
                            <div className="flex items-center justify-between w-full gap-3 md:gap-24 xl:gap-60">
                                <div className="w-[60%] justify-start">
                                    <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Hora de salida</p>
                                </div>
                                <div className="w-[40%] justify-start">
                                    <p className="text-gray md:text-[20px] text-base font-itcbook">
                                        {isEvent ? (eventData?.departureDate ? formatDate(eventData.departureDate) : "-") : "-"}
                                    </p>
                                </div>
                            </div>
    
                            <div className="flex items-center justify-between w-full gap-3 md:gap-24 xl:gap-60">
                                <div className="w-[60%] justify-start">
                                    <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Peso final </p>
                                </div>
                                <div className="w-[40%] justify-start">
                                    <p className="text-gray md:text-[20px] text-base font-itcbook">{eventData?.ouputWeighting ? `${eventData.ouputWeighting} kg` : "-"} </p>
                                </div>
                            </div>
    
                            <div className="flex items-center justify-between w-full gap-3 md:gap-24 xl:gap-60">
                                <div className="w-[60%] justify-start">
                                    <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Peso neto </p>
                                </div>
                                <div className="w-[40%] justify-start">
                                    <p className="text-gray md:text-[20px] text-base font-itcbook">{pesoNeto}</p>
                                </div>
                            </div>
                            
                            <div className="flex items-center justify-between w-full gap-3 md:gap-24 xl:gap-60">
                                <div className="w-[60%] justify-start">
                                    <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Producto</p>
                                </div>
                                <div className="w-[40%] justify-start">
                                    <p className="text-gray md:text-[20px] text-base font-itcbook">
                                        {isEvent ? eventData?.product?.productName ||  getProductNameById(eventData?.idProduct) || "-" : "-"}
                                    </p>                            
                                </div>
                            </div>
    
                            <div className="flex items-center justify-between w-full gap-3 md:gap-24 xl:gap-60">
                                <div className="w-[60%] justify-start">
                                    <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Placa carreta</p>
                                </div>
                                <div className="w-[40%] justify-start">
                                    <p className="text-gray md:text-[20px] text-base font-itcbook">
                                    {isEvent ? (eventData?.wagonPlate === "0" ? "-" : eventData?.wagonPlate) : "-"}
    
                                    </p>                            
                                </div>
                            </div>
    
                            <div className="flex items-center justify-between w-full gap-3 md:gap-24 xl:gap-60">
                                <div className="w-[60%] justify-start">
                                    <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Número ensaque</p>
                                </div>
                                <div className="w-[40%] justify-start">
                                    <p className="text-gray md:text-[20px] text-base font-itcbook">
                                        {isEvent ? (eventData?.baggingCode === "0" ? "-" : eventData?.baggingCode) : "-"}
                                    </p>                            
                                </div>
                            </div>
    
                            <div className="flex items-center justify-between w-full gap-3 md:gap-24 xl:gap-60">
                                <div className="w-[60%] justify-start">
                                    <p className="md:text-2xl text-[18px] text-blue font-itcmedium">N° Contenedor</p>
                                </div>
                                <div className="w-[40%] justify-start">
                                    <p className="text-gray md:text-[20px] text-base font-itcbook">
                                    {isEvent ? (eventData?.container === "00000000000" ? "-" : eventData?.container) : "-"}
                                    </p>                            
                                </div>
                            </div>
    
                            <div className="flex items-center justify-between w-full gap-3 md:gap-24 xl:gap-60">
                                <div className="w-[60%] justify-start">
                                    <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Guía de Remisión</p>
                                </div>
                                <div className="w-[40%] justify-start">
                                    <p className="text-gray md:text-[20px] text-base font-itcbook">
                                    {!isEvent
        ? visitaData?.remissionGuide === "00-0000000" || !visitaData?.remissionGuide?.trim()
            ? "-"
            : visitaData?.remissionGuide
        : eventData?.visit?.remissionGuide === "00-0000000" || !eventData?.visit?.remissionGuide?.trim()
            ? "-"
            : eventData?.visit?.remissionGuide}                                    </p>                            
                                </div>
                            </div>
                            <div className="flex items-center justify-between w-full gap-3 md:gap-24 xl:gap-60">
                                <div className="w-[60%] justify-start">
                                    <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Observación de entrada</p>
                                </div>
                                <div className="w-[40%] justify-start">
                                    <p className="text-gray md:text-[20px] text-base font-itcbook">
                                    {isEvent ? (eventData?.observationOfEntry === null ? "-" : eventData?.observationOfEntry) : "-"}

                                    </p>                            
                                </div>
                            </div>
    
                            <div className="flex items-center justify-between w-full gap-3 md:gap-24 xl:gap-60">
                                <div className="w-[60%] justify-start">
                                    <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Observación de salida</p>
                                </div>
                                <div className="w-[40%] justify-start">
                                    <p className="text-gray md:text-[20px] text-base font-itcbook">
                                        {isEvent ? (eventData?.observationOfExit === null ? "-" : eventData?.observationOfExit) : "-"}
                                    </p>                            
                                </div>
                            </div>
                            
                        </div> 
    
                        <div className="grid justify-center w-full gap-4 pt-16 justify-items md:justify-start md:ml-16 lg:ml-0 xl:justify-center sm:flex md:flex sm:w-full sm:justify-start sm:gap-0 sm:grid-cols-none">
                                {/* Botón Descargar */}
                                <button onClick={handleDownload}
                                    className="flex gap-4 sm:h-[64px] xl:z-10 h-[46px] text-lg text-center text-[#77A042] font-itcdemi">
                                    <img
                                        src={figure2}
                                        alt="Descargar"
                                        className="w-[32px] h-[27.8px]" 
                                    />
                                    Descargar
                                </button>
    
                                {/* Botón Compartir */}
                                <button className="flex gap-4 sm:px-24 px-[35px] xl:z-10  sm:h-[64px] h-[46px] text-lg text-center text-[#77A042] font-itcdemi">
                                    <img
                                        src={figure3}
                                        alt="Compartir"
                                        className="w-[22px] h-[26px]" 
                                    />
                                    Compartir
                                </button>
    
                                <div className="col-span-2 ml-28 sm:ml-0 md:ml-0">
                                    {/* Botón Escanear - se posiciona en el medio */}
                                    <button onClick={handleScanClick}
                                        className="flex gap-4 sm:h-[64px] h-[46px] xl:z-10  text-lg text-center text-[#77A042] font-itcdemi">
                                        <img
                                            src={figure4}
                                            alt="Escanear"
                                            className="w-[28px] h-[28px]" 
                                        />
                                        Escanear
                                    </button> 
                                </div>                
                            </div>
    
                        <div className="flex w-full sm:px-[5%] justify-center  gap-2">
                            <button className="sm:px-24 px-[35px] inline-block xl:z-10  sm:h-[64px] h-[46px] text-lg text-center text-white bg-green rounded-2xl font-itcdemi">
                                Imprimir
                            </button>   
                        </div>  
                    </div>
                    <Programate/>
                </div>
            </div>
        </div>  
      );
  }
  